import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useContext, useMemo, forwardRef } from 'react';
import { getPropFilter } from 'utils/ui';
var TableContext = /*#__PURE__*/createContext(null);
export var TABLE_CONTEXT_PROP_NAMES = ['mobileViewBreakpoint', 'stickyHeaderOffset', 'rowMinHeight', 'shadedHeader', 'pl', 'pr'];
export var tableContextPropFilter = getPropFilter(TABLE_CONTEXT_PROP_NAMES);
function TableContextProvider(_ref) {
  var children = _ref.children,
    mobileViewBreakpoint = _ref.mobileViewBreakpoint,
    stickyHeaderOffset = _ref.stickyHeaderOffset,
    rowMinHeight = _ref.rowMinHeight,
    shadedHeader = _ref.shadedHeader,
    pl = _ref.pl,
    pr = _ref.pr;
  var contextValue = useMemo(function () {
    return {
      mobileViewBreakpoint: mobileViewBreakpoint,
      stickyHeaderOffset: stickyHeaderOffset,
      rowMinHeight: rowMinHeight,
      shadedHeader: shadedHeader,
      pl: pl,
      pr: pr
    };
  }, [mobileViewBreakpoint, stickyHeaderOffset, rowMinHeight, shadedHeader, pl, pr]);
  return /*#__PURE__*/React.createElement(TableContext.Provider, {
    value: contextValue
  }, children);
}
function useTableContext() {
  var context = useContext(TableContext);
  if (context === null) {
    throw Error('useTableContext must be used inside of a TableContextProvider component');
  }
  return context;
}
function withTableContext(Component) {
  var WrappedComponent = /*#__PURE__*/forwardRef(function (props, ref) {
    var contextProps = useTableContext();
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref
    }, props, contextProps));
  });
  WrappedComponent.displayName = "".concat(Component.displayName, "WithTableContext");
  return WrappedComponent;
}
export { TableContextProvider, useTableContext, withTableContext };